import {
  GET_SITE_DETAILS_REQUEST,
  GET_SITE_DETAILS_SUCCESS,
  GET_SITE_DETAILS_FAILURE,
  CLEAR_SITES,
} from "actions/site";

const initialState = {
  loading: false,
  error: {},
  lastUpdated: new Date().getTime(),
  details: {
    online: true,
  },
};

export default function site(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SITE_DETAILS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SITE_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        details: {
          ...payload,
          price_export: payload.price_export
            ? payload.price_export * -1.0
            : payload.price_export,
        },
        lastUpdated: new Date().getTime(),
      };
    }

    case GET_SITE_DETAILS_FAILURE: {
      return {
        ...state,
        loading: false,
        details: {},
      };
    }

    case CLEAR_SITES: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
}
